import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const RoleHome = ({ user }) => {
  if (user.role === "super_admin") return <Navigate to="/admin/institutes" replace />;
  if (user.role === "institute_admin") return <Navigate to="/institute/coaches" replace />;
  if (user.role === "coach") return <Navigate to="/coach/users" replace />;
  if (user.role === "user") {
    if (!user.onboarding_completed) return <Navigate to="/onboarding" replace />;
    return <Navigate to="/me/dashboard" replace />;
  }
  return <Navigate to="/login" replace />;
};

export const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <div className="text-[#5C635A] tracking-[0.2em] uppercase text-xs">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <RoleHome user={user} />;
  return children;
};

export const RoleRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
        <div className="text-[#5C635A] tracking-[0.2em] uppercase text-xs">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <RoleHome user={user} />;
};
